export default class Timeline {
  constructor() {
    document.querySelectorAll('[js-timeline]').forEach((section) => this.init(section));
  }

  init(section) {
    this.section = section;
    this.yearsNav = section.querySelector('[js-timeline-years]');
    this.yearButtons = Array.from(section.querySelectorAll('[js-timeline-year]'));
    this.items = Array.from(section.querySelectorAll('[js-timeline-item]'));

    if (!this.items.length) return;

    this.activeYear = this.items[0]?.dataset.year || '';
    this.isScrollingTo = false;

    this.onScroll = this.onScroll.bind(this);
    this.onYearClick = this.onYearClick.bind(this);

    this.yearButtons.forEach((button) => {
      button.addEventListener('click', this.onYearClick);
    });

    this.setActiveYear(this.activeYear, false);
    this.updateActiveYear();

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll);

    if (typeof window.lenis?.on === 'function') {
      window.lenis.on('scroll', this.onScroll);
    }
  }

  getStickyOffset() {
    const yearsHeight = this.yearsNav?.offsetHeight || 0;
    const headerHeight = 44;
    return headerHeight + yearsHeight + 8;
  }

  onYearClick(event) {
    const button = event.currentTarget;
    const targetId = button.dataset.target;
    const year = button.dataset.year;
    const target = targetId ? document.getElementById(targetId) : null;

    if (!target) return;

    this.isScrollingTo = true;
    this.setActiveYear(year, true);

    const top = target.getBoundingClientRect().top + window.scrollY - this.getStickyOffset();

    if (window.lenis && typeof window.lenis.scrollTo === 'function') {
      window.lenis.scrollTo(top, {
        onComplete: () => {
          this.isScrollingTo = false;
        },
      });
    } else {
      window.scrollTo({ top, behavior: 'smooth' });
      window.setTimeout(() => {
        this.isScrollingTo = false;
      }, 600);
    }
  }

  setActiveYear(year, scrollPill = false) {
    if (!year) return;

    this.activeYear = year;

    this.yearButtons.forEach((button) => {
      const isActive = button.dataset.year === year;
      button.classList.toggle('-active', isActive);

      if (isActive && scrollPill && this.yearsNav) {
        const list = this.yearsNav.querySelector('.ird-timeline__years-list');
        if (!list) return;

        const buttonLeft = button.offsetLeft;
        const buttonWidth = button.offsetWidth;
        const listWidth = list.clientWidth;
        const nextScroll = Math.max(0, buttonLeft - (listWidth - buttonWidth) / 2);

        list.scrollTo({ left: nextScroll, behavior: 'smooth' });
      }
    });

    this.items.forEach((item) => {
      item.classList.toggle('is-active', item.dataset.year === year);
    });
  }

  onScroll() {
    if (this.isScrollingTo) return;
    this.updateActiveYear();
  }

  updateActiveYear() {
    const offset = this.getStickyOffset();
    let activeItem = this.items[0];

    this.items.forEach((item) => {
      const rect = item.getBoundingClientRect();
      if (rect.top - offset <= 0) {
        activeItem = item;
      }
    });

    const nextYear = activeItem?.dataset.year || '';
    if (nextYear && nextYear !== this.activeYear) {
      this.setActiveYear(nextYear, true);
    }
  }
}
